import React from 'react';

export const FormRequired = () => (
    <span className='text-danger'>*</span>
);